import { assert } from '@chainflip/utils/assertion';
import { useMutation } from '@tanstack/react-query';
import useToast from '@/shared/hooks/useToast';
import { FLIP_SYMBOL } from '@/shared/utils/env';
import { getViemError } from '@/shared/utils/functions';
import type TokenAmount from '@/shared/utils/TokenAmount';
import useEvmScAccount from './useEvmScAccount';

export default function useApproveScUtils({ onSuccess }: { onSuccess?: () => void } = {}) {
  const { delegationSDK: sdk } = useEvmScAccount();
  const toast = useToast('approve-sc-utils');

  return useMutation({
    mutationFn: async (amount: TokenAmount) => {
      assert(sdk, 'Delegation SDK is not initialized');

      toast.loading(`Approving ${amount.toFormatted()} ${FLIP_SYMBOL}...`);

      const maybeTxHash = await sdk.approve(amount);

      return { maybeTxHash, amount };
    },
    onSuccess({ maybeTxHash, amount }) {
      if (maybeTxHash === null) {
        toast.success(`Existing ${FLIP_SYMBOL} allowance was high enough`);
      } else {
        toast.success(`Successfully approved ${amount.toFormatted()} ${FLIP_SYMBOL}`);
      }
      onSuccess?.();
    },
    onError(error) {
      toast.error('Approval failed', { description: getViemError(error) });
    },
  });
}
